/* eslint-disable import-x/no-default-export */
import Chance from 'chance';

const chance = new Chance();

export default (description: string) => {
  const rightToWorkCredential = {
    verification: {
      result: description,
    },
    expiryFormatted: chance.pickone([
      'Valid until 1 Jan 2025',
      'Permanent verification',
    ]),
    status:
      chance.d4() === 1
        ? null
        : chance.pickone(['New', 'ExpiresSoon', 'Expired']),
    manageVerificationUrl:
      'https://certsy.com/right-to-work?utm_source=seek&utm_medium=referral&utm_campaign=profile-manage&utm_content=right-to-work',
  };

  return rightToWorkCredential;
};
